import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const serializableEstimationDatasFields: FieldInterface[] = []

export const serializableEstimationDatasRelations: RelationInterface[] = [
  {
    key: '_estimate',
    originKey: 'estimate',
    objectType: OBJECT_TYPES.estimate,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_estimateSeries',
    originKey: 'estimate_series',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_estimateSeriesMax',
    originKey: 'estimate_series_max',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_estimateSeriesMin',
    originKey: 'estimate_series_min',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_rentEstimate',
    originKey: 'rent_estimate',
    objectType: OBJECT_TYPES.estimate,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_rentEstimateSeries',
    originKey: 'rent_estimate_series',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_rentEstimateSeriesMax',
    originKey: 'rent_estimate_series_max',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_rentEstimateSeriesMin',
    originKey: 'rent_estimate_series_min',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_saleEstimate',
    originKey: 'sale_estimate',
    objectType: OBJECT_TYPES.estimate,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_saleEstimateSeries',
    originKey: 'sale_estimate_series',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_saleEstimateSeriesMax',
    originKey: 'sale_estimate_series_max',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
  {
    key: '_saleEstimateSeriesMin',
    originKey: 'sale_estimate_series_min',
    objectType: OBJECT_TYPES.estimateTimeseries,
    isMultiple: false,
    canBeNull: true,
  },
]
